<div class="container-fluid padMob webView" style="padding-left: 20px; padding-right: 15px;" #epltable>
    <div class="row">
        <div class="col-md-12 col-12 col-sm-12 padHeder" style="padding-bottom: 15px;">
            <div class="col-md-2 col-12 col-sm-12 pad0 inLneBlk">
                <h2  class="lblHeader newHeader"> Project Types</h2>
            </div>
            <div class="col-md-10 col-12 col-sm-12 pad0 inLneBlk txtRight">
                <div class="input-icons search" style="display: inline-block; width: 100%;">
                <span>
                    <i class="fa fa-search" style="left: 27px !important;top: -1px; color: #999;"></i>
                    <!-- <span class="fa fa-search" style="color: blue"  *ngIf="Items.length != 0"></span> -->
                    <input class="form-control formCtlFltr bgwhite" ng-model="search.term" placeholder="Search" matInput
                    (keyup)="applyFilter($event)" #input
                    style="text-align: left; margin-left: 7px; display: inline-block; border-radius: 3px !important;
                    box-shadow: none; width: 18%; font-size: 13px; text-indent: 25px;" type="text">
                </span>
                <span class="label orangeBadge-wb fntSz"
                    style="padding: 5px 7px; margin-left: 7px; border-radius: 3px; background: #fff; border: 1px solid; color: 4caf50; height: 30px;"
                    *ngIf="Items.length  > 0"><span>
                    Total Project Types : {{Items.length | lacFormat:0 }}</span>
                </span>
                <span *ngIf="right.InvMstrs"><span class="btn orangeButton" (click)="open()"
                    style="margin-left: 7px;font-size: 13px !important; color:#fff; border-radius: 3px; height: 30px; vertical-align: baseline;"><i
                    class="zmdi zmdi-plus" aria-hidden="true" style="position: relative; top: 0px; font-size: 13px"></i>
                    <span style="margin-left: 7px;" title="Create Project Type">Create Project Type</span></span></span>
                    <!-- Hidden - Not Implemented -->
                    <span *ngIf="(isAdmin == true) && (Items.length > 0)" class="btn darkBlueButton fntSz"
                        (click)="exportToExcelActivities()" title="Export to Excel"
                        style="cursor: pointer; margin-left: 7px; line-height: 19px; padding: 5px 8px !important; display: none;">
                        <span><i class="fa fa-file-excel-o" aria-hidden="true"></i></span></span>
                </div>
            </div>
        </div>

        <div class="col-md-12 col-12 col-sm-12 pad0" style="padding: 15px;">
            <div class="col-md-12 col-12 col-sm-12 pad0 bzMatTbl shadow">
                <table mat-table [dataSource]="dataSource" matSort style="width: 100%; border-radius: 3px;">
                    <ng-container matColumnDef="ItemName">
                    <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                        Project Type
                    </th>
                    <td mat-cell *matCellDef="let item" style="width: 25%; text-align: left;">
                        <div class="inLneBlk" style="width: 90%; cursor: pointer;" (click)="openItemEdit(item);">
                        {{item.ItemName}} </div>
                    </td>
                    </ng-container>
        
                    <ng-container matColumnDef="ItemCode">
                    <th class="header header-Table" style="cursor: pointer;" mat-header-cell *matHeaderCellDef mat-sort-header>
                        Code
                    </th>
                    <td mat-cell *matCellDef="let item" style="text-align: left; width: 12%; cursor: pointer;"
                        (click)="openItemEdit(item);">{{item.ItemCode }}</td>
                    </ng-container>
                    
                    <ng-container matColumnDef="Actions">
                    <th class="header header-Table" mat-header-cell *matHeaderCellDef style="text-align: right;">
                    </th>
                    <td mat-cell *matCellDef="let item" style="text-align: right;">
                        <div class="lableBtnOrange inLneBlk" style="cursor: pointer;" (click)="openItemEdit(item);" *ngIf="right.InvMstrs">
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                        </div>
                        <div class="lableBtnGray inLneBlk brdrRadius3" style="margin-left: 7px;" (click)="deleteItem(item)" *ngIf="right.InvMstrs">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                        </div>
                    </td>
                    </ng-container>
        
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let item; columns: displayedColumns"></tr>
                    <tr class="mat-row" *matNoDataRow style="text-align: left;">
                        <td class="mat-cell" colspan="4" style="background-color: #fff;">
                            <div class="nrf" style="border-radius: 3px;">No project types found.</div>
                        </td>
                    </tr>
                </table>
                <mat-paginator [pageSize]="10" [pageSizeOptions]="[5,10,20]">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>  

<div class="container-fluid padMob bg mobView bggray" style="padding-left: 15px; padding-right: 0px;">
    <div class="row ">
        <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite padHeder" style="padding-bottom: 0px;">
            <div class="col-md-6 col-6 col-sm-6 pad0 inLneBlk">
            <h4 style="font-size: 30px;" class="newHeader"> Project Types</h4>
            </div>
            <span class="btn darkBlueButton"
                    style="margin-right: 15px !important; float: right; position: relative; padding: 2px 9px; top: 1px;"
                    (click)="backToHomeBtn()">
                        <i class="zmdi zmdi-arrow-left" style="margin-right: 5px;"></i>Back
            </span>
        </div>
        <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite" style="padding: 10px 30px 0px 15px; display: block;">
            <div class="input-icons search">
            <span class="fa fa-search" style="top: 17px !important;"></span>
            <input #inputStockSearch id="mySearch" class="form-control formCtlFltr brdrRadius3" [(ngModel)]="search" placeholder="Search"
                style="padding-left: 35px !important; box-shadow: none; border: 1px solid #e4e4e4 !important; width: 100%; float: left;"
                type="text">
            </div>
        </div>
        <div class="col-md-12 col-12 col-sm-12 pad0 bgWhite padHeder" style="padding-top: 10px; padding-bottom: 0px;">
            <div style="display: flex; justify-content: start; align-items: center; column-gap: 8px; margin-bottom: 10px;">
                <span *ngIf="right.InvMstrs">
                    <span class="btn orangeButton font13" (click)="open()">
                    <span style="margin-right: 8px;">
                        <i class="zmdi zmdi-plus" aria-hidden="true" style="font-size: 13px;"></i>
                    </span>
                    <span>Create Project Type</span>
                    </span>
                </span>
            </div>
        </div>
        <div class="col-md-12 col-12 col-sm-12 pad0">
            <div *ngIf="Items.length == 0" class="col-md-12 col-sm-12 col-xs-12" style="margin-top: 15px;">
                <span class="nrf" style="font-size: 15px; border-radius: 3px; padding: 6px 12px; color: #333;">No project types found.</span>
            </div>
            <div class="col-md-12 col-sm-12 col-12 pad0 bgWhite pad15 marginTp font13" (click)="openItemEdit(x);"
                *ngFor="let x of Items | filter:'ItemName,ItemCode':search">
                <div class="col-md-12 col-12 col-sm-12 pad0">
                    <div class="col-md-8 col-8 col-sm-8 pad0 inLneBlk">
                        <span style="font-weight: bold; color: #444;">{{x.ItemName}}</span>
                    </div>
                </div>
                <div class="col-md-12 col-12 col-sm-12 pad0">
                    <div class="col-md-8 col-8 col-sm-8 inLneBlk pad0 font12">
                    <!-- <span style="color: #777;">{{x.CategoryName}}</span> -->
                    <!-- Itemcode -->
                        <div  style="font-size: 12px; color: grey;">
                            # {{x.ItemCode}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>